import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    trigger: '[data-in-view-trigger]',
  },
}

export default class InViewItem {
  constructor(options = {}) {
    this.$contentRoot = document
    this.$trigger = null
    this.isInView = false
    this.index = 0

    this.setInitializedStyle = ($trigger, i) => {}
    this.inViewAnimation = async ($trigger, i) => {}
    this.outOfViewAnimation = async ($trigger, i) => {}

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.setInitializedStyle(this.$trigger)
  }

  _set$() {
    if (!this.$trigger) {
      this.$trigger = this.$contentRoot.querySelector(this.$names.trigger)
    }
  }

  run() {
    if (this.iom) {
      const inViewCb = () => {
        if (!this.isInView) {
          this.isInView = true

          this.inViewAnimation(this.$trigger, this.index).then(() => {
            this.iom.remove(this.$trigger)
          })
        }
      }

      const outOfViewCb = () => {
        if (this.isInView) {
          requestAnimationFrame(() => {
            this.outOfViewAnimation(this.$trigger, this.index).then(() => {
              this.iom.remove(this.$trigger)
            })
          })
        }
      }

      this.iom.add(this.$trigger, inViewCb, outOfViewCb)
    }
  }

  destroy() {
    if (this.iom) {
      if (this.$trigger) {
        this.iom.remove(this.$trigger)
      }
    }
  }
}